import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";

import { useUiStore } from "@/stores/uiStore";

i18next
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${import.meta.env.VITE_APP_VERSION}`,
    },
    lng: useUiStore.getState().locale,
    fallbackLng: "fa",
    ns: ["common", "zod"],
    defaultNS: "common",
    interpolation: { escapeValue: false },
  });

useUiStore.subscribe(
  (state) => state.locale,
  (locale) => {
    i18next.changeLanguage(locale);
  },
);
